import React, { useEffect } from 'react';

interface GoogleTagManagerProps {
  id: string; // GTM ID (e.g., 'GTM-XXXXXXX')
}

const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({ id }) => {
  useEffect(() => {
    // Add GTM script to head
    const addGTMScript = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
      `;
      document.head.insertBefore(script, document.head.firstChild);
    };

    // Add GTM noscript iframe to body
    const addGTMNoScript = () => {
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    };

    // Initialize GTM
    addGTMScript();
    addGTMNoScript();

    // Clean up function
    return () => {
      // This is mostly for development purposes
      const scripts = document.querySelectorAll(`script[src*="googletagmanager.com/gtm.js?id=${id}"]`);
      scripts.forEach(script => script.remove());
      
      const noscripts = document.querySelectorAll('noscript');
      noscripts.forEach(noscript => {
        if (noscript.innerHTML.includes(`ns.html?id=${id}`)) {
          noscript.remove();
        }
      });
    };
  }, [id]);

  return null; // This component doesn't render anything
};

export default GoogleTagManager;